import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ICONS } from '../../constants/icons.constants';
import { SvgIconData } from '../../models/icon.model';

@Component({
  selector: 'app-icon',
  imports: [],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
})
export class IconComponent implements OnInit, OnChanges {
  @Input() name!: string;
  @Input() width = '16';
  @Input() height = '16';
  @Input() viewBox = '0 0 16 16';

  iconData: SvgIconData | undefined;

  ngOnInit(): void {
    this.updateIconData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name'] && !changes['name'].firstChange) {
      this.updateIconData();
    }
  }

  private updateIconData(): void {
    this.iconData = ICONS[this.name];
    if (!this.iconData) {
      console.warn(`Icon "${this.name}" not found in iconSVGPaths.`);
    }
  }
}
